import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SiteuserService} from '../../services/siteuser.service';

@Component({
  selector: 'app-userdashboard-sidebar',
  templateUrl: './userdashboard-sidebar.component.html',
  styleUrls: ['./userdashboard-sidebar.component.css']
})
export class UserdashboardSidebarComponent implements OnInit {
  constructor(private usrObj:SiteuserService, 
    private router:Router) { }

  ngOnInit(): void {

    if(this.usrObj.loggedIn() == false){
      this.router.navigate(['/login']);
    }

  }

  logout(){
    localStorage.removeItem('sajid');
    localStorage.removeItem('sajuname');
    localStorage.removeItem('sajtoken');
    this.router.navigate(['order-online']); 
  }
  

}
